function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useState, useEffect } from 'react';
import { Row, Col, Button } from 'reactstrap';
import { useWorkFlow } from "../../../../contexts/workflow";
import Collector from "../../../../../services/collector";
import { _Icon as Icon } from "../../../../core/common";
import { WeverCoreContext, _translate } from "../../../../../services/core";
import CategorizedResponse from "./categorized";
import SequenceInformations from "../information";
var SequenceType = function SequenceType(_ref) {
  var elements = _ref.elements,
    onChange = _ref.onChange,
    loop = _ref.loop;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isCategoriesVisible = _useState2[0],
    setCategoriesVisible = _useState2[1];
  var _useState3 = useState(1),
    _useState4 = _slicedToArray(_useState3, 2),
    numberSequence = _useState4[0],
    setNumberSequence = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    displayResume = _useState6[0],
    setDisplayResume = _useState6[1];
  var _useState7 = useState(),
    _useState8 = _slicedToArray(_useState7, 2),
    selection = _useState8[0],
    setSelection = _useState8[1];
  var _useWorkFlow = useWorkFlow(),
    collector = _useWorkFlow.collector,
    dispatcher = _useWorkFlow.dispatcher;
  var _useContext = useContext(WeverCoreContext),
    locale = _useContext.locale;
  var currentOrder = collector.currentOrder,
    currentQuestion = collector.currentQuestion,
    responses = collector.responses,
    specialData = collector.specialData;
  var blocParentOrder = currentOrder.split('.');
  blocParentOrder.pop();
  if (currentQuestion.loop || blocParentOrder[blocParentOrder.length - 1] === '__blank_loop') {
    blocParentOrder.pop();
  }
  console.log('bloc order', blocParentOrder);
  var sequencesAlias = 'sequences' + blocParentOrder.join('_');
  var questionKey = 'q_' + currentQuestion.id + currentQuestion.loop;

  // gestion du changement et mise en place de l'alias type mode_X_Y
  // on récupère le bon alias
  var handleOnChange = function handleOnChange(response, value, type, extraAlias) {
    var currentResponses = Collector.getCurrentOrderResponses(currentOrder, responses);
    var questionResponses = currentResponses === null || currentResponses === void 0 ? void 0 : currentResponses.responses;
    var nbResponse = Object.keys(questionResponses || {}).length + 1;
    var updatedResponses = {};
    // l'alias de la question est mises au moment du dispatch dans le contexte.
    var newAlias = numberSequence + '_' + nbResponse;
    var isFound = false;

    /**
     * -------------------------------
     *  SI les réponses existent alors on créé un nouveau tableau sans
     *  les réponses à supprs (et bonne alias)
     * -------------------------------
     */
    if (nbResponse > 0 && questionResponses) {
      // On récupère l'alias en cours pour cette valeur.
      Object.keys(questionResponses).forEach(function (alias) {
        if (questionResponses[alias] === response.value || questionResponses[alias] === response.alias) {
          isFound = true;
          // Si on enlève l'élément
          if (!value) {
            return;
          }
        }
        var letAlias = alias.replace(currentQuestion.alias, '');
        // on save sous l'lias _mode_x_Y
        updatedResponses[letAlias] = questionResponses[alias];
      });
    }

    // rentre la nouvelle valeur.
    if (value && !isFound) {
      updatedResponses[newAlias] = response.alias;
      setCategoriesVisible(false);
    }

    /**
     * -------------------------------
     *  ON recréé les alias à partir de l'index
     *  Permet d'éviter d'avoir un seul élément et qu'il soit à __mode_x_2 par exemple.
     * -------------------------------
     */
    var formatedResponses = {};
    var responsesFormatted = {};
    Object.keys(updatedResponses).forEach(function (key, index) {
      var value = updatedResponses[key];
      delete updatedResponses[key];
      // sépare de questionAlias__mode_X_Y en mode_X_Y;
      var arrayKey = key.split('_');
      var length = arrayKey.length;
      var newAlias = arrayKey[length - 2] + '_' + (index + 1);
      formatedResponses[newAlias] = value;
      responsesFormatted[currentQuestion.alias + '_' + newAlias] = value;
    });

    /**
     * Permet d'avoir des données dans la catégories "specialData."
     * ça évite de boucler dans l'arbre pour chercher les données
     * Et afficher correctement les informations.
     */
    var sequenceNumber = doWeNeedToDisplayResume();
    var updatedSpecialData = specialData || {};
    if (!updatedSpecialData[sequencesAlias]) {
      updatedSpecialData[sequencesAlias] = {};
    }
    if (!updatedSpecialData[sequencesAlias]["number_".concat(sequenceNumber)]) {
      updatedSpecialData[sequencesAlias]["number_".concat(sequenceNumber)] = {};
    }
    updatedSpecialData[sequencesAlias]["number_".concat(sequenceNumber)] = {
      responses: responsesFormatted,
      currentOrder: currentOrder,
      currentQuestion: currentQuestion
    };
    dispatcher({
      type: 'specialData',
      value: updatedSpecialData
    });
    onChange(null, formatedResponses, type, extraAlias);
  };

  /**
   * Permet de vérifier la visibilité
   * @param {object} response
   * @returns
   */
  var getSelectionName = function getSelectionName(item) {
    if (!elements) {
      return null;
    }
    var itemElement = null;
    elements.forEach(function (element) {
      if (element.alias === item || element.value === item) {
        itemElement = element;
      }
    });
    return itemElement;
  };
  var doWeNeedToDisplayResume = function doWeNeedToDisplayResume() {
    var firstLoop = currentOrder.indexOf('__blank') !== -1;
    var hasLoop = currentOrder.indexOf('_loop') !== -1;
    var sequenceNumber = 1;

    // si c'est pas la 1ere boucle alors on peut afficher le résumé.
    if (!firstLoop && hasLoop) {
      currentOrder.split('.').forEach(function (key) {
        if (key.indexOf('_loop') !== -1) {
          var keyWithoutLoop = key.replace('_loop', '');
          var splitted = keyWithoutLoop.split('_');
          sequenceNumber = parseInt(splitted[splitted.length - 1], 10);
        }
      });
      setDisplayResume(true);
    }
    setNumberSequence(sequenceNumber);
    return sequenceNumber;
  };
  useEffect(function () {
    var currentResponses = Collector.getCurrentOrderResponses(currentOrder, responses);
    var sequenceNumber = doWeNeedToDisplayResume();
    if (!currentResponses || selection && selection.length > 0) {
      return function () {
        setDisplayResume(false);
        setSelection(null);
        setNumberSequence(null);
      };
    }
    var answers = currentResponses.responses;
    var realResponses = {};
    Object.keys(answers).forEach(function (key) {
      var explodedKey = key.split('_');
      var responseSequence = parseInt(explodedKey[explodedKey.length - 2], 10);
      if (responseSequence === sequenceNumber) {
        realResponses[key] = answers[key];
      }
    });
    currentResponses.responses = realResponses;
    var updatedSpecialData = specialData || {};
    if (!updatedSpecialData[sequencesAlias]) {
      updatedSpecialData[sequencesAlias] = {};
    }

    /**
     * Permet de mettre les données dans special Data au chargement, 
     * dans le cas où on est sur de l'édition et non de la création.
     * (si la personne fait suivant)
     */
    if (!updatedSpecialData[sequencesAlias]["number_".concat(sequenceNumber)]) {
      updatedSpecialData[sequencesAlias]["number_".concat(sequenceNumber)] = _objectSpread(_objectSpread({}, currentResponses), {}, {
        currentOrder: currentOrder,
        currentQuestion: currentQuestion
      });
      console.log('dispatcher', {
        updatedSpecialData: updatedSpecialData
      });
      dispatcher({
        type: 'specialData',
        value: updatedSpecialData
      });
    }
    setSelection(realResponses);
    return function () {
      setDisplayResume(false);
      setSelection(null);
      setNumberSequence(null);
    };
  }, [collector]);
  console.log('INDEX P1', {
    displayResume: displayResume,
    numberSequence: numberSequence
  });
  return /*#__PURE__*/React.createElement(Row, {
    className: "d-flex justify-content-center sequences-container"
  }, displayResume ? /*#__PURE__*/React.createElement(Col, {
    className: "sequence-information col-sm-12 col-md-6 "
  }, /*#__PURE__*/React.createElement(SequenceInformations, {
    showUnder: 2
  })) : null, /*#__PURE__*/React.createElement(Col, {
    className: "sequence-information col-sm-12 col-md-6 "
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    className: "col-sm-12 text-center"
  }, /*#__PURE__*/React.createElement("h5", null, _translate('collectorapp_sequence'), " ", numberSequence), selection && Object.keys(selection).map(function (key) {
    var element = getSelectionName(selection[key]);
    return /*#__PURE__*/React.createElement(Row, {
      className: "element",
      key: key
    }, /*#__PURE__*/React.createElement(Col, {
      className: "col-8"
    }, element.alias === 'mode_marche_a_pied' ? _translate('categorie_marche_a_pied') : element.name[locale]), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Button, {
      color: "defaut",
      size: "sm",
      onClick: function onClick() {
        return handleOnChange(element, false, null, 'sequences' + blocParentOrder.join('_'));
      }
    }, /*#__PURE__*/React.createElement(Icon, {
      name: "minus-circle",
      className: "icon"
    }))));
  })))), /*#__PURE__*/React.createElement(Col, {
    className: "col-12 d-flex justify-content-center"
  }, /*#__PURE__*/React.createElement(Col, {
    className: "col-sm-12 col-lg-4 col-md-6 checkbox-tag"
  }, /*#__PURE__*/React.createElement(Button, {
    className: "collectorCheckboxTag text-left ".concat(isCategoriesVisible ? 'active' : ''),
    style: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'left'
    },
    onClick: function onClick() {
      return setCategoriesVisible(!isCategoriesVisible);
    }
  }, _translate('collectorapp_add_sequence_mode'), ' ', /*#__PURE__*/React.createElement(Icon, {
    className: "icon sequence-type-down-btn",
    name: "chevron-down"
  })), /*#__PURE__*/React.createElement(CategorizedResponse, {
    elements: elements,
    onChange: handleOnChange,
    index: loop,
    className: "sequence-categories ".concat(isCategoriesVisible ? 'active' : ''),
    onClose: function onClose() {
      return setCategoriesVisible(false);
    }
  }))));
};
export default SequenceType;